/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Scan_GoalInputs */

const en_portal_scan_goal = /** @type {(inputs: Portal_Scan_GoalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`today, target from your coach`)
};

const pl_portal_scan_goal = /** @type {(inputs: Portal_Scan_GoalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dziś, cel od trenera`)
};

/**
* | output |
* | --- |
* | "today, target from your coach" |
*
* @param {Portal_Scan_GoalInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_scan_goal = /** @type {((inputs?: Portal_Scan_GoalInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Scan_GoalInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_scan_goal(inputs)
	return en_portal_scan_goal(inputs)
});